export const Icons = () => {
  return (
    <>
      {/* PWA Icons - Preload critical above-the-fold icons */}
      <link rel="preload" as="image" href="/meta/icon-192.png" type="image/png" />
      <link rel="icon" type="image/png" sizes="192x192" href="/meta/icon-192.png" />
      <link rel="apple-touch-icon" href="/meta/icon-192.png" />
      
      {/* Modern format with fallback - Preload logo as it's critical */}
      <link rel="preload" as="image" href="/meta/logo.svg" type="image/svg+xml" />
      <link rel="icon" type="image/webp" href="/meta/favicon.webp" />
      <link rel="alternate icon" type="image/svg+xml" href="/meta/logo.svg" />
      <link rel="alternate icon" type="image/png" href="/meta/favicon.png" />
    </>
  );
};